export default function () {
	let useCookieFilters = getCookie('core_cookies_filter');

	if (useCookieFilters) {
		let url = window.location.href;
		window.history.replaceState({}, document.title, url.split('?')[0]);
	}

	function getCookie(name) {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
		}

		return null;
	}

	$(function () {
		$('.archive-filter').change(function () {
			updateFilters();
		});
		registerPagination();
	});

	function updateFilters(page, insert) {
		let filters = {};

		$('.archive-filter').each(function () {
			if (useCookieFilters || $(this).val()) {
				filters[$(this).attr('name')] = $(this).val();
			}
		});

		let url = $('.archive__module').first().attr('data-url');

		if (page) {
			url += 'page/' + page;
		}

		if (Object.keys(filters).length) {
			url = url + '?' + $.param(filters);
		}

		if (!useCookieFilters) {
			history.pushState({}, '', url);
		}

		if (!insert) {
			$('.archive__items').hide();
			$('.archive__loader').addClass('loading pt-4');
		}

		loadItems(url, insert)
	}

	function registerPagination() {
		$('#previous-page').click(function (event) {
			$('.archive__lazyload--before').addClass('loading');
			updateFilters($(this).attr('data-page'), 'before');
			event.preventDefault();
			event.stopPropagation();
		});
		$('#next-page').click(function (event) {
			$('.archive__lazyload--after').addClass('loading');
			updateFilters($(this).attr('data-page'), 'after');
			event.preventDefault();
			event.stopPropagation();
		});
	}

	function loadItems(url, insert) {
		$.get(url, function (response) {
			if (insert === 'before') {
				$('.archive__items').prepend($(response).find('.archive__items').html());
				$('.archive__lazyload--before').html($(response).find('.archive__lazyload--before').html());
			} else if (insert === 'after') {
				$('.archive__items').append($(response).find('.archive__items').html());
				$('.archive__lazyload--after').html($(response).find('.archive__lazyload--after').html());
			} else {
				$('.archive__items').html($(response).find('.archive__items').html());
				$('.archive__lazyload--before').html($(response).find('.archive__lazyload--before').html());
				$('.archive__lazyload--after').html($(response).find('.archive__lazyload--after').html());
			}
			registerPagination();
		}).always(function () {
			$('.archive__lazyload').removeClass('loading');
			$('.archive__items').show();
			$('.archive__loader').removeClass('loading pt-4');
		});
	}
}
